module.exports = __webpack_public_path__ + "images/2a9a8b9be83d2dbc5adfa2c6456d9a00.svg";